module.exports = {
      id: "comm-entertainment-usage",
      viewBox: "0 0 269.757 51.703",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#comm-entertainment",
      toString: function () {
        return this.url;
      }
    }